import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth uses httpOnly cookies (set by backend on login/register/emergent-callback).
// `withCredentials: true` ensures the browser sends the session cookie on every request.
// We deliberately do NOT store the JWT in localStorage — it would be exposed to XSS.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// File download URL. The auth cookie is sent automatically by the browser
// for same-origin resources served through the ingress path (/api/*).
export const fileUrl = (fileId) => `${API}/files/${fileId}`;
